import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private auth: AuthService;

  constructor(private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log('intercept');
    let requestToForward = req;

    if (this.auth === undefined) {
      this.auth = this.injector.get(AuthService);
    }
    if (this.auth !== undefined) {
      const token = this.auth.getToken();
      if (token !== '') {
        let tokenValue = 'Bearer ' + token;
        if (this.auth.authType === 'basic') {
          tokenValue = 'Basic ' + token;
        }
        requestToForward = req.clone({setHeaders: {Authorization: tokenValue}});
      }
    } else {
      console.debug('authService undefined: NO auth header!');
    }

    return next.handle(requestToForward);
  }
}
